import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';
import { pause } from '@/stores/player';

export function openIdentifySpeakersDialog() {
  pause();
  EventBus.dispatch(CustomEvents.OpenSpeakersIdentification);
}
